// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

// A signed-out tab reloads, so nothing of the session it had stays in memory
// eslint-disable-next-line import/prefer-default-export
export const reloadPage = () => window.location.reload();
